import { z } from "zod";

export const DeleteAgentResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.null(),
});

export type DeleteAgentResponse = z.infer<typeof DeleteAgentResponseSchema>;